import type { NavigationStyle } from '../controllers/navigation-style-context';
import type { NavigationBarApiResponse } from '../types';

export const DEFAULT_NAVIGATION_OPTIONS: NavigationStyle = {
	padding: true,
	fixedAtTop: false,
	backgroundColor: '#FFFFFF',
	textColor: '#172B4D',
	borderColor: '#DFE1E6',
	borderType: 'NO_BORDER',
	cornerRadius: 8,
};

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function mapApiToNavigationOptions(apiData: NavigationBarApiResponse): NavigationStyle {
	if (!apiData) {
		return DEFAULT_NAVIGATION_OPTIONS;
	}

	return {
		padding: apiData.padding ?? DEFAULT_NAVIGATION_OPTIONS.padding,
		fixedAtTop: apiData.positionType === 'FIXED',
		backgroundColor: apiData.backgroundColor ?? DEFAULT_NAVIGATION_OPTIONS.backgroundColor,
		textColor: apiData.textColor ?? DEFAULT_NAVIGATION_OPTIONS.textColor,
		borderColor: apiData.borderColor ?? DEFAULT_NAVIGATION_OPTIONS.borderColor,
		borderType:
			apiData.borderType === 'BOTTOM_BORDER'
				? 'BOTTOM_BORDER'
				: apiData.borderType === 'ALL_BORDER'
					? 'ALL_BORDER'
					: 'NO_BORDER',
		cornerRadius: apiData.cornerRadius ?? DEFAULT_NAVIGATION_OPTIONS.cornerRadius,
	};
}
